import { InputGroup as BaseInputGroup } from "@chakra-ui/react";

export default BaseInputGroup;
